var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSaco(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#02404F;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.2,8.4c0-0.2-0.1-0.4-0.3-0.6l-1.4-1.1c-0.4-0.3-0.8-0.5-1.3-0.4l-2.7,0V5.6c0-1.3-0.5-2.6-1.3-3.6 c-1.1-1.4-2.7-2.1-4.4-2.1c-1.7-0.1-3.3,0.7-4.4,2.1c-0.8,1-1.2,2.3-1.2,3.6v0.7l-2.6,0h0c-0.5,0-1,0.2-1.3,0.5L4,7.9 C3.9,8,3.8,8.2,3.8,8.4C3.7,8.6,3.6,8.9,3.6,9.1v18.2c0,1.5,1.2,2.7,2.7,2.7h17.3c1.5,0,2.7-1.2,2.7-2.7V9.1 C26.4,8.9,26.3,8.6,26.2,8.4z M10.9,5.6c0-1.1,0.7-4,4-4c1.2-0.1,2.4,0.5,3.1,1.4c0.6,0.7,0.9,1.7,0.9,2.6v0.6l-8,0V5.6z M24.8,27.3 c0,0.6-0.5,1.1-1.1,1.1H6.3c-0.6,0-1.1-0.5-1.1-1.1V9.1c0-0.1,0.1-0.3,0.3-0.3h3.8v1.6c0,0.4,0.4,0.8,0.8,0.8c0.4,0,0.8-0.4,0.8-0.8 V8.9h8v1.6c0,0.4,0.4,0.8,0.8,0.8c0,0,0,0,0,0c0.4,0,0.8-0.4,0.8-0.8V8.9h3.9c0.1,0,0.3,0.1,0.3,0.3V27.3z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaco);
export default __webpack_public_path__ + "static/media/Saco.a8d5ac5319a764b289a14f31c842a55e.svg";
export { ForwardRef as ReactComponent };